import {Component, Injector, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ClaimService} from "../../../../services/claim.service";
import {Claim} from "../../../../model/claim.model";
import {ClaimsBaseComponent} from "../../../claim-base.component";
import {DatePipe} from "@angular/common";
import {DocumentField} from '../../../../model/document-field';
import {ClaimTypes} from '../../../../model/claim-type.model';
import {DocumentHelperService} from "../../../../services/document-helper.service";
import {HospitalizationHelper} from "../../../../model/domestic-helper/hospitalization-helper.model";

@Component({
    selector: 'app-summary-hospitalization-helper',
    templateUrl: './summary-hospitalization-helper.component.html',
    styleUrls: ['./summary-hospitalization-helper.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class SummaryHospitalizationHelperComponent extends ClaimsBaseComponent implements OnInit {

    claim: Claim;
    hospitalizationHelper: HospitalizationHelper
    listOfDocuments: DocumentField[] = [];

    constructor(private claimService: ClaimService,
                private documentHelperService: DocumentHelperService,
                private injector : Injector) {

        super(injector);
        this.claim = this.claimService.getClaim();
        this.hospitalizationHelper = this.claim.getClaimDomesticHelper().getHospitalizationHelper();
        this.listOfDocuments = this.documentHelperService.getListOfDocuments(this.claimService.claim.getDocumentForm().documents,
            this.documentHelperService.getDocumentFormBuilder(ClaimTypes[ClaimTypes.CLAIM_TYPE_DMH_HOSPITAL]).getRequiredDocuments(),
            ClaimTypes[ClaimTypes.CLAIM_TYPE_DMH_HOSPITAL]);
    }
    
    ngOnInit() { }

    returnYesOrNo(value: string) {
        if ('Yes' === value) {
            return this.translate.instant("claimSection.generalLabels.radioButtonLabels.yes");
        } else {
            if ('No' === value) {
                return this.translate.instant("claimSection.generalLabels.radioButtonLabels.no");
            }
        }
        return '';
    }
    returnYesOrNoBoolean(value: boolean) {
        if (value) {
            return this.translate.instant("claimSection.generalLabels.radioButtonLabels.yes");
        } else {
            if (!value) {
                return this.translate.instant("claimSection.generalLabels.radioButtonLabels.no");
            }
        }
        return '';
    }

    getDate(dt: Date) {
        if (dt && dt != null) {
            return new DatePipe('en-US').transform(dt, "dd/MM/yyyy");
        }
        else {
            return "";
        }
    }

}
